export default {
  apiPath: 'https://staging-api.goodcards-services.com/api',
  enableDevMode: true,
};
